module.exports = __webpack_public_path__ + "img/sb01.edb0915b.png";